import React from 'react';
interface CardProps {
  label: string;
  icon?: string;
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
}
function Card({ label, icon, className = '', children, onClick }: CardProps) {
  return (
    <div 
      className={`card ${className}`} 
      data-label={label}
      onClick={onClick}
      style={{ 
        cursor: onClick ? 'pointer' : 'default',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
      }}
    >
      {icon && (
        <div className="card-icon">
          <img src={icon} alt={label} />
        </div>
      )}
      {children}
    </div>
  );
}
export default Card; 